import axios from 'axios'
import { useAuthStore } from '../../zustand/authentication/use-auth-store'
import rules from '../../../proxyConfig/rules'
import { rewritePath } from '../../utils/pathRewriter'
import { useMtlsCertificateStore } from '../../zustand/mtls-certificate/use-mtls-certificate-store.jsx'

const api = axios.create({
  baseURL: rules.target,
  headers: {
    accept: 'application/json, text/plain, */*',
    'X-Platform': 'WEB'
  }
})

api.CancelToken = axios.CancelToken
api.isCancel = axios.isCancel

// Interceptor to include dynamic headers
api.interceptors.request.use((config) => {
  const { path, baseURL } = rewritePath({
    path: config.url,
    baseURL: self.location.origin
  })

  config.baseURL = baseURL
  config.url = path

  // if the request is marked with skipHeaders, clean all headers
  if (config.skipHeaders) {
    config.headers = {}
    return config
  }

  // Verify if header Authorization already exists
  const hasCustomAuthorization = config.headers && config.headers.Authorization

  // If no custom Authorization header exists, add the one from the auth store
  if (!hasCustomAuthorization) {
    const token = useAuthStore.getState().token
    if (token && config.headers) {
      config.headers.Authorization = `${token.token_type} ${token.access_token}`
    }
  }
  return config
})

// Interceptor to detect expired token
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      if (
        error.response.data &&
        error.response.data.error === 'invalid_token' &&
        error.response.data.error_description &&
        error.response.data.error_description.includes('Access token expired:')
      ) {
        const setExpiredToken = useAuthStore.getState().setExpiredToken
        setExpiredToken(true)
      }
    }
    return Promise.reject(error)
  }
)

// Check if the error is related to certificate issues - MTLS Handlers
api.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    const state = useMtlsCertificateStore.getState()

    if (state.isMtlsRequired) {
      if (state.mtlsEnabled && error.config.baseURL.includes(state.endpoint)) {
        const setIsMtlsRequired = state.setIsMtlsRequired

        setIsMtlsRequired(true)
      }
    }

    return Promise.reject(error)
  }
)

export default api
